<div class="hint">
  <kin-svg [name]="helpText.icon || ''" class="icon icon__small icon__secondary"></kin-svg>
  <div class="text text__hint" [innerHTML]="helpText.text"></div>
</div>
